import { useEffect } from 'react'

export const useBlockBrowserBack = () => {
  useEffect(() => {
    window.history.pushState(null, '', window.location.href)
  }, [])
}
